<a class="form-link link form-control control-bg-gray" readonly routerLink="{{crouterLink}}"
  [queryParams]="cqueryParams">
  {{value|getValueLabel:options:labelField:valueField}}
</a>
